import PropTypes from 'prop-types';
import React from 'react';

import './SelingPriceDisclaimer.scss';

const SelingPriceDisclaimer = ({ text, withBottomSpace }) => {
    if (!text) return null;
    return <div className={`seling-price-disclaimer ${withBottomSpace ? 'bottom-space' : ''}`}>{text}</div>;
};

SelingPriceDisclaimer.defaultProps = {
    text: null,
    withBottomSpace: false,
};

SelingPriceDisclaimer.propTypes = {
    text: PropTypes.string,
    withBottomSpace: PropTypes.bool,
};

SelingPriceDisclaimer.displayName = 'SelingPriceDisclaimer';
export default SelingPriceDisclaimer;
